export const formatCurrency = (value) => {
  const n = Number(value) || 0;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
};

export const DEFAULT_RATES = { leadToOpportunity: 0.25, opportunityToProposal: 0.5, proposalToClose: 0.3 };

export const goalMath = (revenueGoal, dealSize, goalEndDate) => {
  const goal = Number(revenueGoal) || 0;
  const deal = Number(dealSize) || 0;
  if (!goal || !deal) return null;
  const wins = Math.ceil(goal / deal);
  const proposals = Math.ceil(wins / DEFAULT_RATES.proposalToClose);
  const opportunities = Math.ceil(proposals / DEFAULT_RATES.opportunityToProposal);
  const prospects = Math.ceil(opportunities / DEFAULT_RATES.leadToOpportunity);
  const days = goalEndDate ? Math.max(1, Math.ceil((new Date(goalEndDate) - new Date()) / 86400000)) : null;
  const winsPerMonth = days ? (wins / (days / 30)).toFixed(1) : null;
  return { wins, proposals, opportunities, prospects, days, winsPerMonth };
};

export const ENTITY_TYPES = ["company", "fund", "practice", "agency", "nonprofit", "facility", "government"];
export const SENIORITY = ["c_suite", "vp", "director", "manager", "partner", "founder"];

export const sizeLabel = (entityType) => (entityType === "fund" ? { key: "AUM", min: "minAUMUSD", max: "maxAUMUSD", money: true } : { key: "Employees", min: "minEmployees", max: "maxEmployees", money: false });

export const EMPTY_SPEC = {
  summary: "", entityTypes: ["company"], industries: [], parkedIndustries: [], industryCodes: [], searchTerms: [], personas: [], seniority: [], geos: [],
  size: { minEmployees: null, maxEmployees: null, minRevenueUSD: null, maxRevenueUSD: null, minAUMUSD: null, maxAUMUSD: null },
  signals: [], regulatoryContext: [], negatives: [], lookalikeSeeds: [], breadth: "balanced", confidence: 0,
};

export const STEPS = [
  { id: "identify", title: "Your company" },
  { id: "confirm", title: "What we found" },
  { id: "customers", title: "Your customers" },
  { id: "targeting", title: "Who to target" },
  { id: "preview", title: "Preview" },
  { id: "commit", title: "Your goal" },
  { id: "launch", title: "First hunt" },
];

export const LAST_EDIT_STEP = 5;
